import { Outlet } from 'react-router-dom'
import HeaderSiteOfficiel from '@/components/site-officiel/header-site-officiel'
import FooterSiteOfficiel from '@/components/site-officiel/footer-site-officiel'

export default function SiteOfficielLayout() {
  return (
    <main>
      <HeaderSiteOfficiel />
      <Outlet />
      <FooterSiteOfficiel />
    </main>
  )
}
